import { requst } from '../config'

// 获取所有 Preplot
export const getPreplotListDataApi = projectId => {
    const url = `/setting/preplot/list${projectId}`
    return requst.get(url)
}

// 获取坐标系统参考 list
export const getWKtList = () => {
    const url = `/map/common/wktList`
    return requst.get(url)
}

// 查询分页数据
export const getPreplotPageApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => (query += `&${item}=${params[item]}`))
    const result = query.slice(1)
    url = `/setting/preplot/page?` + result
    return requst.get(url)
}

// 上传文件
export const postPreplotDataApi = (params, file) => {
    const url = `/setting/preplot/importData`
    const formData = new FormData()
    formData.append('file', file)
    return requst({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params,
        data: formData,
    })
}

// 修改文件
export const putPreplotDataApi = (params, file) => {
    const url = `/setting/preplot`
    const formData = new FormData()
    formData.append('file', file)
    return requst({
        url,
        method: 'put',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params,
        data: formData,
    })
}

// 下载文件
export const downPreplotFileApi = id => {
    const url = `setting/preplot/download/${id}`
    return requst.get(url, {
        responseType: 'blob',
    })
}

/* 删除 Preplot 表格数据 */
export const deletPreplotTableDataApi = id => {
    const url = `/setting/preplot/${id}`
    return requst.delete(url)
}

/* 通过 id 获取文件 */
export const getPreplotIdDataApi = id => {
    const url = `/setting/preplot/${id}`
    return requst.get(url)
}

// ---------------------------- 地形

// 上传 地形 文件
export const postTerrainPreplotDataApi = (params, file) => {
    const url = `/setting/terrain/file/importData`
    const formData = new FormData()
    formData.append('file', file)
    return requst({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params,
        data: formData,
    })
}

// 获取所有 Preplot
export const getTerrainPreplotListDataApi = projectId => {
    const url = `/setting/terrain/file/listAll?projectId=${projectId}`
    return requst.get(url)
}

// 下载 地形 文件
export const downTerrainPreplotFileApi = id => {
    const url = `/setting/terrain/file/download/${id}`
    return requst.get(url, {
        responseType: 'blob',
    })
}

// 保存文件信息
export const postSaveTerrainPreplotDataApi = params => {
    const url = `/setting/terrain/file/save`
    return requst.post(url, params)
}

/* 删除 Preplot 地形 表格数据 */
export const deletTerrainPreplotTableDataApi = id => {
    const url = `/setting/terrain/file/delete?id=${id}`
    return requst.delete(url)
}